function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import appApis, { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['user_profiles']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8092')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8092')
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = 'Bearer ' + window.userInfo.accessToken;
  return config;
};

//appApisGTW.before(beforeMiddleware)
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = '/user_profiles';
var DOMAIN_AREAS = '/areas';
var DOMAIN_USER_PROFILES = '/profiles';
var DOMAIN_TABLES = '/tables';
var DOMAIN_ASSIGNMENTS = '/assignments';
export default _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
  getAreas: function getAreas(data) {
    var _this = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_AREAS + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this.getAreas(data);
      });
    });
  },
  getAreaById: function getAreaById(data) {
    var _this2 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_AREAS + '/get/' + data.area_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this2.getAreaById(data);
      });
    });
  },
  createArea: function createArea(data) {
    var _this3 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_AREAS + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this3.createArea(data);
      });
    });
  },
  updateArea: function updateArea(data) {
    var _this4 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_AREAS + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this4.updateArea(data);
      });
    });
  },
  deleteAreaById: function deleteAreaById(data) {
    var _this5 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_AREAS + '/delete/' + data.area_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this5.deleteAreaById(data);
      });
    });
  },
  getUserProfiles: function getUserProfiles(data) {
    var _this6 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_USER_PROFILES + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this6.getUserProfiles(data);
      });
    });
  },
  getAssignmentById: function getAssignmentById(data) {
    var _this7 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/get/' + data.record_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAssignmentById) obtener assignment en user profile';
      return validateError(err, message, function () {
        _this7.getAssignmentById(data);
      });
    }).finally(function () {
      tasks.lockScreen.unlock();
    });
  },
  createUserProfile: function createUserProfile(data) {
    var _this8 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_USER_PROFILES + '/create', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this8.createUserProfile(data);
      });
    });
  },
  updateUserProfile: function updateUserProfile(data) {
    var _this9 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_USER_PROFILES + '/update', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this9.updateUserProfile(data);
      });
    });
  },
  deleteUserProfileById: function deleteUserProfileById(data) {
    var _this0 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_USER_PROFILES + '/delete/' + data.userprofile_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this0.deleteUserProfileById(data);
      });
    });
  },
  getUserProfileByArea: function getUserProfileByArea(data) {
    var _this1 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_USER_PROFILES + '/get_by_area/' + data.area_id, body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this1.getUserProfileByArea(data);
      });
    });
  },
  getAssignments: function getAssignments(data) {
    var _this10 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/get_all', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAreas) listar areas en user profile';
      return validateError(err, message, function () {
        _this10.getAssignments(data);
      });
    });
  }
}, "getAssignmentById", function getAssignmentById(data) {
  var _this11 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = {
    login: login,
    values: {
      area_id: data.area_id,
      userprofile_id: data.userprofile_id
    }
  };
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/get/' + data.record_id, body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAssignmentById) obtener assignment por id';
    tasks.lockScreen.unlock();
    return validateError(err, message, function () {
      return _this11.getAssignmentById(data);
    });
  });
}), "createAssignment", function createAssignment(data) {
  var _this12 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/create', body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    return validateError(err, message, function () {
      _this12.createAssignment(data);
    });
  });
}), "updateAssignment", function updateAssignment(data) {
  var _this13 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/update', body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    return validateError(err, message, function () {
      _this13.updateAssignment(data);
    });
  });
}), "deleteAssignmetById", function deleteAssignmetById(data) {
  var _this14 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/delete/' + data.assignment_id, body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    return validateError(err, message, function () {
      _this14.deleteAssignmetById(data);
    });
  });
}), "getTables", function getTables(data) {
  var _this15 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_TABLES + '/get_all', body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    return validateError(err, message, function () {
      _this15.getTables(data);
    });
  });
}), "crudTables", function crudTables(data) {
  var _this16 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_TABLES + '/crud', body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    return validateError(err, message, function () {
      _this16.crudTables(data);
    });
  });
}), "downloadAssignments", function downloadAssignments(data) {
  var _this17 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/download', body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    return validateError(err, message, function () {
      _this17.downloadAssignments(data);
    });
  });
}), "validateTable", function validateTable(data) {
  var _this18 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_TABLES + '/validate_table', body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    return validateError(err, message, function () {
      _this18.validateTable(data);
    });
  });
}), "uploadValidateTables", function uploadValidateTables(data) {
  var _this19 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_TABLES + '/upload_validate_table', body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    return validateError(err, message, function () {
      _this19.uploadValidateTables(data);
    });
  });
}), "reloadAssignment", function reloadAssignment(data) {
  var _this20 = this;
  var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
  var body = _objectSpread({
    login: login
  }, data);
  tasks.lockScreen.lock();
  return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/reload_assignment', body, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    tasks.lockScreen.unlock();
    return res.data;
  }).catch(function (err) {
    var message = '(getAreas) listar areas en user profile';
    return validateError(err, message, function () {
      _this20.reloadAssignment(data);
    });
  });
});